<template>
  <div>
    <h2
      v-if="listMessages?.searchTitle"
      class="def-header-2"
      v-html="listMessages?.searchTitle"
    ></h2>

    <div class="catalog-top pagination-scroll-js">
      <div class="catalog-top__filter">
        <div v-if="!isLoveYouClubCatalog">
          <div class="catalog-top__filter-mobile" @click="handlerMobileFilter">
            <svg>
              <use xlink:href="#svg-filter-menu"></use>
            </svg>
            <h5 class="catalog-top__title">{{ filterMessages?.title }}</h5>
          </div>
          <span class="catalog-top__close" @click="handlerShowFilter">
            <span> {{ catalogSmartFilter.messages?.collapse }}: </span>
          </span>
        </div>
        <div v-else>
          <DefLink @click="showLoveYouClubModal">
            {{ listMessages?.changeLoveYouClubSelection }}
          </DefLink>
        </div>

        <div class="list-view">
          <div
            :class="{ 'list-view__active': productListCardType === 2 }"
            class="list-view__two"
            @click="changeProductListCardType(2)"
          >
            <div class="list-view__square"></div>
            <div class="list-view__square"></div>
          </div>
          <div
            class="list-view__one"
            :class="{ 'list-view__active': productListCardType === 1 }"
            @click="changeProductListCardType(1)"
          >
            <div class="list-view__square"></div>
          </div>
        </div>
      </div>
      <!--Mobile Filter-->
      <div v-if="!isLoveYouClubCatalog" class="catalog-top__sort">
        <span class="catalog-top__sort-title">
          <span> {{ catalogSmartFilter.messages?.sort }}: </span>
        </span>
        <SelectVueSort :result="catalogSort" @change="changePageData" />
      </div>

      <!--      @link https://sova-jewels.atlassian.net/wiki/spaces/LOV/pages/238813194/US+14.1+- -->
      <!--      @see https://sova-jewels.atlassian.net/browse/LOV-182-->
      <div v-else class="catalog-top__filter__love-you-club">
        <DefButtonPrimary :disabled="!catalogSectionList.items.length > 0" @click="updatePageData">
          {{ listMessages?.generateAgain }}
        </DefButtonPrimary>
      </div>
    </div>

    <div :class="{ 'catalog-grid': productListCardType === 3 }">
      <!--Десктоп фильтр-->
      <!--Меняем вид фильтра когда список товара открыт на всю страницу десктоп-->
      <CatalogFilter
        v-if="!isOpenFilter && screenWidth >= 992"
        :result="catalogSmartFilter"
        class="catalog-filter"
        @changeFilter="changeFilter"
        @resetFilter="changePageData"
        @remove="handlerRemove"
      />

      <DefImg
        v-if="isLoveYouClubCatalog && !catalogSectionList.items.length > 0"
        :result="getLyClubCurrentItem.detailPicture"
      />

      <ProductsList
        :result="catalogSectionList"
        :catalog-list-show="productListCardType"
        :filter="showSmallFilterDesktop"
        :is-show-pagination="!isLoveYouClubCatalog"
      />
    </div>
    <SeoText />
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex';
import CatalogFilter from '@components/Catalog/filter/CatalogFilter.vue';
import SelectVueSort from '@components/Catalog/SelectVueSort.vue';
import ProductsList from '@components/Catalog/ProductsList.vue';
import SeoText from '@components/Seo/SeoText.vue';
import DefLink from '@components/Def/DefLink/DefLink.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import { screenWidth } from '@use/useDeviceInfo';
import useModal from '@use/useModal/useModal';
import Analytics from '@/utils/Analytics';

export default {
  name: 'Catalog',
  components: {
    SeoText,
    ProductsList,
    SelectVueSort,
    CatalogFilter,
    DefLink,
    DefButtonPrimary,
    DefImg,
  },
  data() {
    return {
      showSmallFilterDesktop: false,
      screenWidth,
      modal: useModal(),
    };
  },
  computed: {
    ...mapState({
      listMessages: ({ catalog }) => catalog.data.catalogSectionList.messages,
      catalogSectionList: ({ catalog }) => catalog.data.catalogSectionList,
      filterMessages: ({ catalog }) => catalog.data.catalogSmartFilter?.messages,
      productListCardType: ({ catalog }) => catalog.data.productListCardType,
      isOpenFilter: ({ catalog }) => catalog.data.isOpenFilter,
      catalogSort: ({ catalog }) => catalog.data.catalogSort,
      catalogSmartFilter: ({ catalog }) => catalog.data.catalogSmartFilter,
      club: ({ club }) => club?.data,
    }),
    ...mapGetters({
      getLyClubCurrentItem: 'club/getCurrentItem',
    }),
    isLoveYouClubCatalog() {
      return this.catalogSectionList?.isLoveYouClubCatalog;
    },
  },
  methods: {
    ...mapMutations({
      changeProductListCardType: 'catalog/changeProductListCardType',
      setOpenFilter: 'catalog/setOpenFilter',
      deleteSelectedItem: 'catalog/deleteSelectedItem',
      setLoveYouClubIsOpen: 'club/setIsOpen',
    }),
    ...mapActions({
      changePageData: 'catalog/changePageData',
      updatePageData: 'catalog/updatePageData',
      changeFilter: 'catalog/changeFilter',
    }),
    handlerShowFilter() {
      if (this.productListCardType === 3) {
        this.changeProductListCardType(4);
      } else if (this.productListCardType === 4) {
        this.changeProductListCardType(3);
      }

      this.setOpenFilter(!this.isOpenFilter);
    },
    async handlerRemove(item) {
      this.deleteSelectedItem(item);
      setTimeout(this.changeFilter, 4);
    },
    handlerMobileFilter() {
      if (this.screenWidth < 992) {
        // this.setOpenFilter(true);
        this.modal.show(
          CatalogFilter,
          {
            result: this.catalogSmartFilter,
            onChangeFilter: this.handlerChangeFilter,
            onResetFilter: this.changePageData,
            onRemove: this.handlerRemove,
          },
          { padding: false, width: '100%' }
        );
      }
    },
    async handlerChangeFilter() {
      await this.changeFilter();
      this.setOpenFilter(false);
      if (this.screenWidth < 992) {
        this.modal.hide();
      }
    },
    showLoveYouClubModal() {
      this.setLoveYouClubIsOpen(true);
    },
  },
  mounted() {
    document.onreadystatechange = () => {
      if (document.readyState == 'complete') {
        const historyScrollTop = window.history?.state?.scroll?.top;
        if (historyScrollTop && window.scrollY !== historyScrollTop) {
          App.helpers.scrollPageTo(historyScrollTop, 20);
        }
      }
    };
    /**
     * @link https://sova-jewels.atlassian.net/browse/LOV-182
     * @see https://sova-jewels.atlassian.net/wiki/spaces/LOV/pages/238813194/US+14.1+-
     */
    if (this?.isLoveYouClubCatalog) {
      this.handlerShowFilter();
    }

    Analytics.viewProductList(this.catalogSectionList?.items);
  },
};
</script>

<style lang="scss" scoped>
.catalog-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  color: var(--text-colour-primary);
  flex-direction: column;
  @include point-md {
    flex-direction: row;
  }
  &__filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
    color: var(--text-colour-secondary);
    width: 100%;
    margin-bottom: 16px;
    @include point-md {
      width: auto;
      margin-bottom: 0;
    }
    @include point-lg {
      justify-content: flex-start;
      color: var(--text-colour-primary);
    }
    svg {
      width: 16px;
      height: 10px;
      margin-right: 8px;
      fill: var(--border-colour-primary);
      @include point-md {
        width: 24px;
        height: 15px;
      }
    }
    &__love-you-club {
      flex-direction: column;
    }
  }
  &__filter-mobile {
    display: flex;
    align-items: center;
    svg {
      display: block;
      @include point-lg {
        display: none;
      }
    }
  }
  &__title {
    margin-right: 8px;
    font-size: rem(14);
    letter-spacing: 0.08em;
    text-transform: uppercase;
    @include point-md {
      font-size: rem(18);
    }
  }
  &__close {
    font-size: rem(12);
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--text-colour-secondary);
    display: none;
    &:hover {
      cursor: pointer;
    }
    @include point-lg {
      display: inline-block;
    }
  }
  &__sort {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    width: 100%;
    text-align: left;
    padding: 10px 16px;
    @include point-md {
      padding: 0;
      flex-direction: row;
      background-color: transparent;
      width: 260px;
      text-align: center;
      align-items: center;
    }
  }
  &__sort-title {
    font-size: rem(16);
    margin-bottom: 4px;
    color: #757575;
    @include point-md {
      color: var(--text-colour-primary);
      margin-right: 8px;
      margin-bottom: 0px;
    }
  }
}
.catalog-grid {
  @include point-lg {
    display: grid;
    grid-template-columns: 25% 75%;
    grid-column-gap: 4px;
  }
}
.searchTitle {
  text-align: center;
  text-transform: uppercase;
  font-size: 20px;
  font-weight: 500;
}

.list-view {
  display: flex;
  align-items: center;
  @include point-md {
    display: none;
  }
  &__two {
    display: flex;
    margin-right: 20px;
    .list-view__square {
      width: 7px;
      &:first-child {
        margin-right: 2px;
      }
    }
  }
  &__square {
    background: #dfdfdf;
    height: 16px;
    width: 10px;
  }
  &__active {
    .list-view__square {
      background: #618eaf;
    }
  }
}
.catalog-filter {
  display: none;
  @include point-lg {
    display: block;
  }
}
</style>
